import { css, type Theme } from "@emotion/react";

import { animations, dimensions, helpers } from "@styles";

export const tag = (theme: Theme) => css`
  ${animations.transition()}

  height: auto;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  border-radius: ${dimensions.pillBorderRadius};
  display: inline-flex;

  &:active,
  &:focus {
    svg path {
      fill: ${theme.system.borderActive};
    }
  }
`;

export const label = css`
  margin-right: 0.25rem;
  ${helpers.ellipsesOverflowHelper};
  max-width: 9.375rem;
`;

export const noEllipses = css`
  max-width: 100%;
`;

export const baseSystemProfile = (theme: Theme) => css`
  background-color: ${theme.system.backgroundBase};
  border: 1px solid ${theme.system.borderBase};
  color: ${theme.system.textLabelEmphasis};

  &:hover {
    border-color: ${theme.system.borderHover};
    color: ${theme.system.textHover};
  }

  &:focus {
    border-color: ${theme.system.borderFocused};
  }

  &:hover:active {
    border-color: ${theme.system.borderActive};
  }
`;

export const closeButton = (theme: Theme) => css`
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    color: ${theme.disabled.text};
  }
`;

export const disabled = (theme: Theme) => css`
  & {
    cursor: not-allowed;
    background-color: ${theme.disabled.background};
    border: 1px solid ${theme.disabled.border};
    color: ${theme.disabled.text};
  }

  &&:hover,
  &&:hover:active,
  &&:active {
    box-shadow: none;
    border-color: ${theme.disabled.border};
    color: ${theme.disabled.text};
    background-color: ${theme.disabled.background};
  }
`;
